import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c6ca57fe&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.css?vue&type=style&index=0&id=c6ca57fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca57fe",
  null
  
)

export default component.exports